import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import {
  SUPPORT_PANEL_ID,
  SUPPORT_SHORTCUT_HINT,
  SUPPORT_TRIGGER_ID,
} from './constants'
import { useSupport } from './SupportProvider'

function HelpIcon() {
  return (
    <svg
      className="support-widget__trigger-icon"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z"
        stroke="currentColor"
        strokeWidth="1.75"
      />
      <path
        d="M9.1 9a3 3 0 0 1 5.8.9c0 2-3 2.25-3 4"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.25h.01"
        stroke="currentColor"
        strokeWidth="2.25"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default function SupportButton() {
  const { isOpen, toggle } = useSupport()

  return (
    <OverlayTrigger
      placement="left"
      overlay={
        <Tooltip id="support-widget-tooltip">
          Need help? Open the IT Support portal ({SUPPORT_SHORTCUT_HINT})
        </Tooltip>
      }
    >
      <button
        id={SUPPORT_TRIGGER_ID}
        type="button"
        className="support-widget__trigger"
        aria-label="Need help? Open the IT Support portal"
        aria-haspopup="dialog"
        aria-expanded={isOpen}
        aria-controls={SUPPORT_PANEL_ID}
        aria-keyshortcuts="Shift+/"
        data-testid="support-widget-trigger"
        onClick={toggle}
      >
        <HelpIcon />
        <span className="support-widget__trigger-label">Need Help?</span>
      </button>
    </OverlayTrigger>
  )
}
